import { StandardRequest, StandardResponse } from "./functions";

export type WorkflowState = "draft" | "pending_approval" | "completed" | "rejected";

/**
 * Raw persisted database document schema for a Workflow entity in Firestore (`workflows/{id}`).
 */
export interface IWorkflow {
  id?: string;
  name: string;
  currentState: WorkflowState;
  assignedTo: string; // Active assignee UID
  ownerId: string; // Creator UID
  memoryId?: string; // Associated memory ID (context)
  workflowType?: "memory_approval" | "contact_link";
  contactId?: string;
  targetUserId?: string;
  contactDisplayName?: string;
  contactEmail?: string;
  createdAt: number;
  updatedAt: number;
}

export type Workflow = IWorkflow;

export type TaskStatus = "pending" | "accepted" | "rejected";

/**
 * Raw persisted database document schema for a Task entity in Firestore (`tasks/{id}`).
 */
export interface ITask {
  id?: string;
  workflowId: string;
  assignedTo: string;
  title: string;
  description: string;
  state: WorkflowState; // The state this task operates in
  status: TaskStatus;
  createdAt: number;
  completedAt?: number;
  taskType?: "memory_approval" | "contact_link";
  contactId?: string;
  targetUserId?: string;
  contactDisplayName?: string;
  contactEmail?: string;
}

export type Task = ITask;

export type TaskModel = Task & {
  workflowName: string;
  memoryTitle?: string;
  assigneeDisplayName?: string;
  assigneeEmail?: string;
  contactName?: string;
  targetUserName?: string;
  targetUserEmail?: string;
};

export type WorkflowModel = Workflow & {
  tasks: TaskModel[];
  ownerDisplayName?: string;
  ownerEmail?: string;
  assigneeDisplayName?: string;
  assigneeEmail?: string;
  memoryTitle?: string;
  contactName?: string;
  targetUserName?: string;
  targetUserEmail?: string;
};

export type CreateWorkflowRequest = StandardRequest & {
  name: string;
  memoryId: string;
  reviewerId: string; // Selected reviewer UID
};

export type CreateWorkflowResponse = StandardResponse & {
  workflowId: string;
};

export type ActionTaskRequest = StandardRequest & {
  taskId: string;
  action: "accept" | "reject";
};

export type GetMyWorkflowsRequest = StandardRequest & {};

export type GetMyWorkflowsResponse = StandardResponse & {
  workflows: Workflow[];
  activeTasks: TaskModel[];
};

export type GetAllWorkflowsRequest = StandardRequest & {};

export type GetAllWorkflowsResponse = StandardResponse & {
  workflows: WorkflowModel[];
  totalWorkflows: number;
  activeTasksCount: number;
};

